// removed by extract-text-webpack-plugin
module.exports = {"label":"_1GUiN","listView":"hhiCx","fileType":"_2AerH","gridView":"_27Pzq","fileTypes":"SKYN0"};